module.exports = __webpack_public_path__ + "static/media/Share.9a98390f.svg";